<template>
  <div class="px-0">
    <div class="container iconos mt-3">
      <div class="col-12 d-md-flex justify-content-center mx-auto py-3 px-0">
        <div class="logo-instt d-block d-inline-block mr-auto">
          <LogoInstitucion
            :idLogo="institucion.codigo"
            :urlWeb="paginaWeb"
            classContenedora="img-fluid w-50 mr-5"
            styleImg="max-width: 8rem;"
          />
        </div>

        <table
          class="table table-borderless table-sm row col-lg-4 mr-3 mr-lg-0"
        >
          <tbody>
            <tr>
              <th scope="col">
                <!--<AñosAcreditacion
                  v-if="institucion.acreditado"
                  :acreditacion="institucion.acreditacion.anios"
                  classImg="mr-3"
                  styleImg="width: 28px; margin: .5rem;"
                />-->
                <img
                  ref="icono-acreditado"
                  src="@/assets/img/iconos/acreditacion-8.svg"
                  class="mr-3"
                  style="width: 28px; margin: 0.5rem"
                />
              </th>
              <td scope="col">
                <strong>{{
                  textoAcreditacion(
                    tipoInstitucion,
                    institucion.acreditado,
                    institucion.acreditacion
                      ? institucion.acreditacion.anios
                      : 0,
                    institucion.observacionAcreditacionCNA
                  )
                }}</strong>
                <img
                  src="@/assets/img/asterisk-solid.svg"
                  v-if="
                    institucion.observacionAcreditacionCNA ||
                      acreditacionEspecialPandemiaCNA
                  "
                  style="width: 0.5rem; margin: 0.4rem"
                />
              </td>
            </tr>

            <tr>
              <th scope="row">
                <img
                  src="@/assets/img/iconos/ICONO _PERIODO ACREDITACION.svg"
                  style="width: 2.5rem; margin: 0.5rem"
                />
              </th>
              <td>
                <strong>Período de Acreditación Institucional:</strong>
                <br />
                {{ textoPeriodoAcreditacion }}
              </td>
            </tr>

            <tr>
              <th scope="row" style="vertical-align: top !important">
                <img
                  src="@/assets/img/iconos/ICONO _AREAS ACREDITADAS.svg"
                  style="width: 2.5rem; margin: 0.5rem"
                />
              </th>
              <td>
                <strong>Áreas Acreditadas:</strong>
                <ul
                  v-if="
                    institucion.areasAcreditadas &&
                      institucion.areasAcreditadas.length > 0
                  "
                >
                  <li
                    v-for="area in institucion.areasAcreditadas"
                    :key="area.index"
                  >
                    {{ area }}
                  </li>
                </ul>
                <ul v-else>
                  <li>Sin áreas acreditadas</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row col-lg-7 d-flex">
          <table
            class="table table-borderless table-sm col col-lg-6 mr-lg-3 d-inline-block border-left border-right"
          >
            <tbody>
              <tr>
                <th scope="row">
                  <img
                    src="@/assets/img/iconos/ICONO _MATRICULA PREGRADO.svg"
                    style="width: 2.5rem; margin: 0.5rem"
                  />
                </th>
                <td>
                  <strong
                    >Matrícula Pregrado {{ anioMatriculaPrePost }}:</strong
                  >
                  <br />
                  {{ formatoNumerico(institucion.matriculaTotalPregrado) }}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <img
                    src="@/assets/img/iconos/ICONO _MATRICULA POSGRADO.svg"
                    style="width: 2.5rem; margin: 0.5rem"
                  />
                </th>
                <td>
                  <strong>{{ tituloPostitulo }}</strong>
                  <br />
                  {{ formatoNumerico(institucion.matriculaTotalPostgrado) }}
                </td>
              </tr>
              <tr>
                <th scope="col">
                  <img
                    src="@/assets/img/iconos/beneficios-estado.svg"
                    style="width: 28px; margin: 0.5rem"
                    class="mr-2"
                  />
                </th>
                <td scope="col">
                  <strong>Beneficios del Estado:</strong>
                  <br />
                  {{ institucion.beneficiosEstatales }}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            class="table table-borderless table-sm col-md-6 col-lg-5 mt-lg-1 mr-0 d-inline-block"
          >
            <tbody>
              <tr>
                <th
                  scope="col"
                  class="text-nowrap"
                  style="vertical-align: top !important"
                >
                  <img
                    src="@/assets/img/iconos/presencia-regiones.svg"
                    style="width: 54px; margin: 0.4rem"
                    class="mr-2"
                  />
                </th>
                <td>
                  <strong>Presencia Regional:</strong>
                  <ul>
                    <li
                      v-for="region in institucion.presenciaRegional"
                      :key="region.index"
                    >
                      {{ region }}
                    </li>
                  </ul>
                  <p v-if="programaAulaVirtual">
                    ** <small>Para programas con modalidad a distancia</small>
                  </p>
                </td>
              </tr>
              <tr class="no-print">
                <th>
                  <FontAwesomeIcon icon="laptop" class="mr-2" />
                </th>
                <td>
                  <div class="ml-2">
                    <a
                      v-if="institucion.contacto"
                      :href="paginaWeb"
                      class="text-negro"
                      target="_blank"
                      >{{ textoPaginaWeb }}</a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="col col-md-12 d-block pl-3 pr-5 mr-auto"
        v-if="
          institucion.observacionAcreditacionCNA ||
            acreditacionEspecialPandemiaCNA
        "
      >
        <p v-if="institucion.observacionAcreditacionCNA" class="text-muted">
          <small>
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
              class="mr-2"
            />
            {{ textoLeyExcepcion }}
          </small>
        </p>
        <p v-if="acreditacionEspecialPandemiaCNA">
          <small>
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
              class="mr-2"
            />
            Acreditación prorrogada en virtud de resolución exenta DJ Nº 051-4.
            <a :href="linkResoulucion" target="_blank">Haz clic aquí</a>, para
            más información.
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AñosAcreditacion from "@/components/generales/iconos/AniosAcreditacion";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import LogoInstitucion from "@/components/generales/iconos/LogoInstitucion";
import {
  faCalendarCheck,
  faMapMarker,
  faUsers,
  faGraduationCap,
  faMapMarkerAlt,
  faLaptop
} from "@fortawesome/free-solid-svg-icons";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import FormatoMonetario from "@/utils/FormatoMonetario.js";
library.add(
  faCalendarCheck,
  faMapMarker,
  faUsers,
  faGraduationCap,
  faMapMarkerAlt,
  faLaptop
);
import MixinsIconos from "@/mixins/iconosInstituciones.js";
export default {
  name: "Iconos",
  props: {
    institucion: { type: Object },
    tipoInstitucion: { type: String }
  },
  components: {
    AñosAcreditacion,
    FontAwesomeIcon,
    Gratuidad,
    LogoInstitucion
  },
  mixins: [MixinsIconos],
  data() {
    return {
      linkResoulucion: CDN.RESOLUCION_COVID_ACREDITACION,
      anioMatriculaPrePost: ANIO_MATRICULA_INST_PRE_POST
    };
  },
  computed: {
    programaAulaVirtual() {
      if (this.institucion.presenciaRegional) {
        if (this.institucion.presenciaRegional.includes("Nacional **")) {
          return true;
        } else {
          return false;
        }
      }
    },
    tituloPostitulo() {
      if (this.tipoInstitucion === "TECNICO_PROFESIONAL") {
        return `Matrícula Postítulo ${this.anioMatriculaPrePost}:`;
      } else {
        return `Matrícula Postgrado ${this.anioMatriculaPrePost}:`;
      }
    },
    paginaWeb() {
      if (this.institucion.contacto) {
        return this.institucion.contacto.paginaWeb;
      } else {
        return "";
      }
    },
    textoPaginaWeb() {
      if (this.institucion.contacto && this.institucion.contacto.paginaWeb) {
        return "Ver Sitio Web";
      } else {
        return "Sitio Web no disponible";
      }
    },
    textoLeyExcepcion() {
      if (this.institucion.observacionAcreditacionCNA) {
        if (this.tipoInstitucion === "TECNICO_PROFESIONAL") {
          return "Los Centros de Formación Técnica estatales creados por Ley 20.910 deben someterse a acreditación ante la CNA en un plazo máximo de seis años contados desde el inicio de sus actividades académicas.";
        } else {
          return "Las Universidades estatales creadas por Ley N° 20.842, no han accedido aun al sistema de acreditación pues se encuentran bajo tutela de otra universidad y disponen de siete años, desde el nombramiento del primer Rector, para someterse por primera vez a un proceso de acreditación.";
        }
      }
    },
    /*textoGratuidad() {
      if (this.institucion.gratuidad) {
        return "Adscrita a Gratuidad";
      } else {
        return "No Adscrita a Gratuidad";
      }
    },*/
    acreditacionEspecialPandemiaCNA() {
      return (
        this.institucion.acreditado && this.institucion.acreditacion.anios === 0
      );
    },
    /*textoAcreditacion() {
      if (this.institucion.acreditado) {
        if (this.acreditacionEspecialPandemiaCNA) {
          if (this.tipoInstitucion === "TECNICO_PROFESIONAL") {
            return "Acreditado";
          } else {
            return "Acreditada";
          }
        } else {
          return `Acreditación Institucional ${
            this.institucion.acreditacion.anios
          } ${this.institucion.acreditacion.anios > 1 ? "años" : "año"}`;
        }
      } else if (this.institucion.observacionAcreditacionCNA) {
        return "Bajo Tutela";
      } else {
        if (this.tipoInstitucion === "TECNICO_PROFESIONAL") {
          return "No Acreditado";
        } else {
          return "No Acreditada";
        }
      }
    },*/
    textoPeriodoAcreditacion() {
      if (this.institucion.acreditado) {
        return this.institucion.acreditacion.periodo;
      } else {
        return "-";
      }
    }
  },
  methods: {
    formatoNumerico(val) {
      if (val > 0) {
        return FormatoMonetario.getFormatoNumerico(val);
      } else {
        return val;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/fichaInstitucion/Iconos.vue